<p-sidebar class="v4-sidebar"
  [(visible)]="sidebarVisible"
  position="right"
  [closeOnEscape]="true"
  [showCloseIcon]="false"
  styleClass="w-25"
>
  <ng-template pTemplate="header">
    <div
      class="d-flex flex-column align-items-center justify-content-center w-100"
    >
      <p-avatar
        *ngIf="image; else placeholder"
        [image]="image"
        size="xlarge"
        shape="circle"
      ></p-avatar>
      <ng-template #placeholder>
        <p-avatar icon="pi pi-user" size="xlarge" shape="circle"></p-avatar>
      </ng-template>
      <h5 class="color-grey">{{ userName }}</h5>
    </div>
  </ng-template>
  <ng-template pTemplate="content" class="p-0" style="padding: 0px">
    <span *ngFor="let item of items">
      <ul class="v4-list-group list-group list-group-flush w-100 p-0" *ngIf="item.visible">
        <a [routerLink]="item.items ? null : item.routerLink"
          routerLinkActive="active"
          class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
           (click)="item.items ? toggleSubitems(item.label) : null">
          <span>
            <i [ngClass]="item.icon" style="font-size: 1.5rem"></i>
            {{ item.label }}
          </span>
          <span class="d-flex align-items-center">
            <i *ngIf="item.items" 
               class="pi" 
               [ngClass]="{'pi-chevron-down': !isItemExpanded(item.label), 'pi-chevron-up': isItemExpanded(item.label)}"
               style="font-size: 1rem; margin-right: 0.5rem">
            </i>
            <span class="badge bg-primary rounded-pill" *ngIf="!item.items">{{ item.badge }}</span>
          </span>
        </a>

        <ul class="list-group list-group-flush" *ngIf="item.items && isItemExpanded(item.label)">
          <ng-container *ngFor="let subitem of item.items">
            <a
              *ngIf="subitem.visible"
              [routerLink]="subitem.routerLink"
              routerLinkActive="active"
              class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
            >
              <span>
                <i [ngClass]="subitem.icon" style="font-size: 1.2rem"></i>
                {{ subitem.label }}
              </span>
              <span class="badge bg-primary rounded-pill">{{
                subitem.badge
              }}</span>
            </a>
          </ng-container>
        </ul>
      </ul>
    </span>
  </ng-template>

  <ng-template pTemplate="footer">
    <ul class="list-group list-group-flush w-100 p-0">
      <button
        (click)="handleLogout()"
        class="list-group-item list-group-item-action btn-color d-flex justify-content-between align-items-center p-3"
      >
        <span>
          <i class="pi pi-fw pi-sign-out" style="font-size: 1.5rem"></i>
          {{ "Log out" | translator }}
        </span>
      </button>
    </ul>
  </ng-template>
</p-sidebar>
<div class="d-flex">
  <!-- <div>
    <div class="nav-btn-light">
      <div class="nav-btn-light-text">منصة الأعمال</div>
      <div class="d-flex">
        <img
          class="svg-icone"
          src="../../../assets/v-4-icone/Vector(5).svg"
          alt="loading"
        />
      </div>
    </div>
  </div> -->
  <!-- <div class="nav-btns">
    <img
      class="svg-icone"
      src="../../../assets/v-4-icone/Vector(5).svg"
      alt="loading"
    />
  </div>
  <div class="nav-btns">
    <img
      class="svg-icone"
      src="../../../assets/v-4-icone/Vector(4).svg"
      alt="loading"
    />
  </div> -->
  <!-- <div class="nav-btns">En</div> -->
  <button
    (click)="sidebarVisible = true"
    class="text-light hambar-v4"
  >
  <img class="hambgur" src="../../../assets/v-4-icone/Frame7.png" alt="loading">
    <!-- <i class="pi pi-bars" style="font-size: 2.1rem !important;margin: 0rem 1rem 0rem 0rem;"></i> -->
  </button>
</div>
